export default function DSA_Dynamic_Programming() {
  return <div>DSA_Dynamic_Programming Component</div>;
}
